import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { ViewConstants } from "src/app/constants";
import { SubSink } from "subsink";
import { IAppCoreState } from "../state";
import { getUserInfo } from "../state/selectors";
import * as Models from '../../shared/model/api/models';

@Injectable()
export class DealServiceInterceptor implements HttpInterceptor {
    public _subs = new SubSink();

    constructor(private readonly _store: Store<IAppCoreState>) { }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let clonedReq: HttpRequest<any> = httpRequest.clone();
        let debugInfo: Models.DebugInfo = {
            'date': new Date().toUTCString(),
            'sender': ViewConstants.CON
        }

        this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
            if (userInfo) {
                debugInfo.salesAssociateName = userInfo.first_name + ' ' + userInfo.last_name;
                debugInfo.salesAssociateUserId = userInfo.UserId;
            };
        });

        const urlPatterns = [
            'deals/dealers/',
            'retail-deals/dealers/',
            'deals/sendDealToFinance',
            'payment-nexgen',
            'email-notification',
            'sms-notification',
            'upload'
          ];
          
          if (urlPatterns.some(pattern => clonedReq.url.includes(pattern)) && clonedReq.body) {
            clonedReq.body.debugInfo = debugInfo;
          }
          
          return next.handle(clonedReq);
    }
}